import { useMemo } from 'react';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { legalTermsModel } from '~/models';
import { useStoreActions } from '~/store/store-context';
export const useLegalTerms = function useLegalTerms() {
    let { refreshOnHookMount = false, withLoader = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { PDF_EMBEDDED_SIGNATURES } = useFeatureFlags();
    const { data: legalTerms, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.LegalTerms
        ],
        queryFn: ()=>api.business.getLegalTerms(),
        refreshOnHookMount,
        withLoader
    });
    // WHY: the single gate for signatures — the server sends the block regardless of the flag.
    const rows = useMemo(()=>{
        const all = legalTerms !== null && legalTerms !== void 0 ? legalTerms : [];
        return PDF_EMBEDDED_SIGNATURES ? all : all.map(legalTermsModel.withoutSignature);
    }, [
        legalTerms,
        PDF_EMBEDDED_SIGNATURES
    ]);
    return {
        legalTerms: rows,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
